import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import EnglishProfileAiDialog from '@/components/yagiprime/EnglishProfileAiDialog.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EnglishProfileAiCard',
  props: {
    currentValue: { default: '' }
  },
  emits: ["adopt-profile"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'adopt-profile', text: string): void
}), expose: any, slots: any, attrs: any }) {





const dialogVisible = ref(false)
const isGenerating = ref(false)

function openDialog() {
  dialogVisible.value = true
}

return { __sfc: true,emit, dialogVisible, isGenerating, openDialog, EnglishProfileAiDialog }
}

})